import React from "react";
import "./SocilaMediaLink.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const SocialMediaLinks = () => {
  return (
    <div className="social-media-icons">
      <div className="two-icons">
        <a
          href="https://www.facebook.com/hemantasahu9583/"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon facebook"
        >
          <FontAwesomeIcon icon={faFacebookF} />
        </a>
        <a
          href="https://www.instagram.com/maa_mangala_studio/"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon instagram"
        >
          <FontAwesomeIcon icon={faInstagram} />
        </a>
      </div>
      <div className="one-icon">
        <a
          href="https://wa.me/8328803919"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon whatsapp"
        >
          <FontAwesomeIcon icon={faWhatsapp} />
        </a>
      </div>
    </div>
  );
};

export default SocialMediaLinks;
